import React from 'react';
import './App.scss';
import Home from './pages/Home';

function App() {
	return (
		<div className="app">
			<Home />
		</div>
	);
}

export default App;
